import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { usePortfolioEconomics } from '../hooks/usePortfolioEconomics';
import { EconomicsFigures, EconomicsUnavailable } from './EconomicsFigures';
/** The portfolio row: every Opportunity counted once, however many Landscapes hold it. */ export function PortfolioTotalCard({ testid = Testids.portfolio.total }) {
    const { data, isLoading, error } = usePortfolioEconomics();
    return /*#__PURE__*/ _jsxs("section", {
        className: "rounded-md border border-border p-3",
        "data-testid": testid,
        children: [
            /*#__PURE__*/ _jsx("h2", {
                className: "mb-2 text-sm font-medium",
                children: "Portfolio"
            }),
            isLoading && /*#__PURE__*/ _jsx("p", {
                className: "text-sm text-muted-foreground",
                children: "Loading…"
            }),
            error && /*#__PURE__*/ _jsx(EconomicsUnavailable, {}),
            data?.portfolio && /*#__PURE__*/ _jsx(EconomicsFigures, {
                figures: data.portfolio
            })
        ]
    });
}
